import { Milestone } from 'models/enums';

const COLORS = {
  NAVY: 'bg-navy',
  GREEN: 'bg-green',
  GRAY: 'bg-dark-gray',
};

type HomeStatus = {
  label: string;
  colorClassName: string;
  isRented: boolean;
};

const status = (label: string, colorClassName = COLORS.NAVY): HomeStatus => ({
  label,
  colorClassName,
  isRented: colorClassName !== COLORS.NAVY,
});

export const HOME_STATUSES: Record<string, HomeStatus> = {
  [Milestone.None]: status('Getting Started'),
  [Milestone.AgreementSigned]: status('Agreement Signed'),
  [Milestone.InspectionScheduled]: status('Inspection Scheduled'),
  [Milestone.InspectionCompleted]: status('Inspection Completed'),
  [Milestone.PostInspectionProposalSent]: status('Proposal Ready'),
  [Milestone.PostInspectionProposalApproved]: status('Getting Show Ready'),
  [Milestone.ShowReady]: status('Show Ready'),
  [Milestone.FullListingPublished]: status('Listed'),
  [Milestone.ListingRepublished]: status('Listed'),
  [Milestone.LeaseExecuted]: status('Lease Signed', COLORS.GREEN),
  [Milestone.MoveInPrepped]: status('Moving In', COLORS.GREEN),
  [Milestone.MoveInReady]: status('Moving In', COLORS.GREEN),
  [Milestone.ResidentMovedIn]: status('Rented', COLORS.GREEN),
  [Milestone.ResidentPlaced]: status('Rented', COLORS.GREEN),
  [Milestone.ManagingAdoptedResidents]: status('Rented', COLORS.GREEN),
  [Milestone.ResidentGaveMoveOutNotice]: status('Moving Out', COLORS.GRAY),
};

export const isRentedMilestone = (milestone: string) =>
  !!HOME_STATUSES[milestone]?.isRented;
